import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar.jsx";
import blogFetch from "../../axios/config";
import { Button, TextField } from "@mui/material";
import { IAddUser } from "./UserGroupsInterfaces";
import { getCookie } from "../../section/cookie";
import LoadingButton from "@mui/lab/LoadingButton";
import Context from "../../context/Context";
import language from "../../nls/language.json";

export default function UpdateUser() {
  const [user, setUser] = useState<IAddUser>({
    User_Active: true,
    user_CompanyId: 1,
    user_Password: "",
    User_Email: " ",
    user_UserName: "",
    User_Matricula: 0,
    User_SAPMatricula: 0,
    user_Sector: null
  });
  const [oldPassword, setOldPassword] = useState<string>("");
  const [oldName, setOldName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [passwordsMatch, setPasswordsMatch] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    let id = getCookie("userId");
    try {
      let response = await blogFetch.get(`/user/${id}`);
      let data = response.data;
      setUser({
        ...user,
        user_CompanyId: data.user_CompanyId,
        User_Email: data.user_Email,
        user_UserName: data.user_UserName,
        User_Matricula: data.user_Matricula,
        User_SAPMatricula: data.user_SAPMatricula,
      });
      setOldName(data.user_UserName);
    } catch (error) {
      console.error(error);
    }
  };

  
  const handleChangeMatricula = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {

    let intValue: number = parseInt(event.target.value);
    setUser({ ...user, User_Matricula: intValue });
  };
  const handleChangeSAPLogin = (event: React.ChangeEvent<HTMLInputElement>) => {
    let intValue: number = parseInt(event.target.value);
    setUser({ ...user, User_SAPMatricula: intValue });
  };
  const handleChangeOldPassword = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setOldPassword(event.target.value);
  };
  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };
  const handleChangeConfirmPassword = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setConfirmPassword(event.target.value);
  };

  const handleChangeUserName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUser({ ...user, user_UserName: event.target.value });
  };

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUser({ ...user, User_Email: event.target.value });
  };

  const updateUser = async () => {
    setPasswordsMatch(true);

    if (password !== confirmPassword) {
      setPasswordsMatch(false);
      return;
    }
    let validUser = {
      USR_userName: oldName,
      USR_password: oldPassword,
    };
    try {
      let login = await blogFetch.post("token", validUser);
    } catch (error) {
      alert("Senha antiga invalida");
      return;
    }
    setLoading(true);
    let id = getCookie("userId");
    const updateUser: IAddUser = {
      user_CompanyId: user.user_CompanyId,
      user_Password: password,
      user_UserName: user.user_UserName,
      User_Email: user.User_Email,
      User_Matricula: user.User_Matricula,
      User_SAPMatricula: user.User_SAPMatricula,
      User_Active: user.User_Active,
      user_Sector: user.user_Sector
    };
    try {
      let response = await blogFetch.put(`/user/${id}`, updateUser);
      let data = response.data;
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div
        className={`app_body ${getStatusSideBar()}`}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div style={{ maxWidth: "600px" }}>
          <h1 style={{ textAlign: "center" }} className="title_tables">
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.config.title}
          </h1>
          <TextField
            disabled
            className="mb-3"
            id="outlined-basic"
            label="Login"
            variant="outlined"
            fullWidth
            value={user?.user_UserName}
            onChange={handleChangeUserName}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <TextField
            disabled
            className="mb-3"
            id="outlined-basic"
            label="SAP Login"
            variant="outlined"
            fullWidth
            value={!user?.User_SAPMatricula ? "" : user?.User_SAPMatricula}
            onChange={handleChangeSAPLogin}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <TextField
            disabled
            className="mb-3"
            id="outlined-basic"
            label="Matrícula"
            variant="outlined"
            fullWidth
            value={!user?.User_Matricula ? "" : user?.User_Matricula}
            onChange={handleChangeMatricula}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <TextField
            className="mb-3"
            id="outlined-basic"
            label="Email"
            variant="outlined"
            fullWidth
            value={user?.User_Email}
            onChange={handleChangeEmail}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <TextField
            className="mb-3"
            id="outlined-basic"
            label="Senha Atual"
            variant="outlined"
            fullWidth
            type="password"
            value={oldPassword}
            onChange={handleChangeOldPassword}
          />
          <TextField
            className="mb-3"
            id="outlined-basic"
            label="Nova Senha "
            variant="outlined"
            fullWidth
            type="password"
            value={password}
            onChange={handleChangePassword}
          />
          <TextField
            className="mb-3"
            id="outlined-basic"
            label="Confirmar Senha"
            variant="outlined"
            fullWidth
            type="password"
            value={confirmPassword}
            onChange={handleChangeConfirmPassword}
          />
          {passwordsMatch ? null : (
            <p style={{ color: "red", fontSize: "14px" }}>
              {(language as Record<string, any>)[selectedCountry.name].Permissoes.config.senhasIncorretas}
            </p>
          )}
          <div style={{ display: "flex", justifyContent: "end" }}>
            {loading ? (
              <LoadingButton loading variant="outlined">
                Submit
              </LoadingButton>
            ) : (
              <Button variant="contained" onClick={updateUser}>
                {(language as Record<string, any>)[selectedCountry.name].Permissoes.config.btnAtualizar}
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
